"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STRUCTURE_TYPE = void 0;
var STRUCTURE_TYPE;
(function (STRUCTURE_TYPE) {
    STRUCTURE_TYPE["FIELD_NAME"] = "structure_type";
    STRUCTURE_TYPE["NEW_BUILDING"] = "new_building";
    STRUCTURE_TYPE["NON_NEW_BUILDING"] = "non_new_building";
    // land has no building (same marker as ParentEntity::NO_BUILDING)
    STRUCTURE_TYPE["NO_BUILDING"] = "none";
})(STRUCTURE_TYPE = exports.STRUCTURE_TYPE || (exports.STRUCTURE_TYPE = {}));
